import React from 'react'
import PropTypes from 'prop-types'
import { Spinner } from 'lp-components'
import { StripeProvider } from 'components'
import StripeAutoRenewalElements from './StripeAutoRenewalElements'

const propTypes = {
  closeEditForm: PropTypes.func,
  customerSessionClientSecret: PropTypes.string,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  stripeSetupIntentId: PropTypes.string,
  submitButtonText: PropTypes.string.isRequired,
}

function AutoRenewalPaymentSetup({
  closeEditForm = null,
  customerSessionClientSecret = null,
  onError = null,
  onSuccess = null,
  onSubmit,
  stripeSetupIntentId = null,
  submitButtonText,
}) {

  // Errors propagate up to parent component's onSubmit error handling
  const handleSubmit = async (formValues) => {
    await onSubmit(formValues)
    if (onSuccess) await onSuccess()
  }

  if (!stripeSetupIntentId) {
    return <Spinner />
  }

  return (
    <StripeProvider>
      <StripeAutoRenewalElements
        closeEditForm={closeEditForm}
        customerSessionClientSecret={customerSessionClientSecret}
        onError={onError}
        onSubmit={handleSubmit}
        stripeSetupIntentId={stripeSetupIntentId}
        submitButtonText={submitButtonText}
        withTerms={true}
      />
    </StripeProvider>
  )
}

AutoRenewalPaymentSetup.propTypes = propTypes

export default AutoRenewalPaymentSetup
